/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Component, EventEmitter, Input, OnInit, Output, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { ApiQuery } from '@app/core/http/api-query';
import { FormGroup } from '@angular/forms';
import { Company } from '@app/settings/companies/company.model';
import { CompaniesService } from '@app/settings/companies/companies.service';
import { PaginatedResponse } from '@app/shared/models/paginated-response.model';
import { CompaniesFormService } from '@app/settings/companies/companies-form.service';
import { Logger } from '@app/core';
import { Router } from '@angular/router';

const log = new Logger('CompanySelectComponent');

@Component({
  selector: 'app-company-select',
  templateUrl: './company-select.component.html',
  styleUrls: ['./company-select.component.scss'],
})
export class CompanySelectComponent implements OnInit, OnDestroy {
  data: Array<Company>;
  apiQuery: ApiQuery = new ApiQuery();
  loader: boolean;
  @Input() parentFormGroup: FormGroup;
  @Input() hideLabel = false;
  @Input() onlyActive = true;
  @Input() isDefaultSO = false;
  @Output() select = new EventEmitter();
  input$ = new Subject<string>();
  @Input() includes: string = null;
  @Input() isModal = true;

  @Input() passFormControlName = 'company_id';
  companyFormControlName: any = this.passFormControlName.replace('_id', '');

  constructor(
    private companyService: CompaniesService,
    private companyFormService: CompaniesFormService,
    private router: Router
  ) {}

  ngOnInit() {
    this.companyFormControlName = this.passFormControlName.replace('_id', '');

    // #69
    this.loadCompanies();

    // const preSelectedCompany = this.parentFormGroup.get('company');
    // const preSelectedCompanyId = this.parentFormGroup.get('company_id');

    /**
     * Попълва избрания хотел на едит.
     * Ако има FormControl 'company' в parentFormGroup.
     * Ако няма ще се опита да го get-не по ID
     */
    // if (preSelectedCompany) {
    //   log.debug('preSelectedCompany', preSelectedCompany);
    //   /*
    //    * Следи за промени в company FormControl-a и когато намери валиден Company спира да следи
    //    */
    //   const preselectedCompanySubscriber = preSelectedCompany.valueChanges.subscribe((company: any) => {
    //     if (company && company.name) {
    //       log.debug('set', company);
    //       this.data = [company];
    //       preselectedCompanySubscriber.unsubscribe();
    //     }
    //   });
    // }
    // else if (preSelectedCompanyId) {
    //   log.debug('preSelectedCompanyId', preSelectedCompanyId);
    //   /*
    //    * Ако не е намерен company FormControl-a търси company_id FormControl и се опитва да get-не company-то по ID
    //    */
    //   const preselectedCompanyIdSubscriber = preSelectedCompanyId.valueChanges.subscribe((companyId: any) => {
    //     if (companyId) {
    //       this.loadCompanyById(companyId);
    //       preselectedCompanyIdSubscriber.unsubscribe();
    //     }
    //   });
    // }

    // this.companySearch();
  }

  patchForm() {
    if (this.isDefaultSO) {
      const defaultCompany = this.data?.find((company) => company.abbreviation === 'T2F');
      if (defaultCompany) {
        // Set the default company for new entries
        this.parentFormGroup.get(this.passFormControlName).setValue(defaultCompany.id);
      }
    }
  }

  setInputToNull() {
    this.parentFormGroup.get(this.passFormControlName).setValue(null);
  }

  loadCompanies(keyword?: string) {
    //this.setInputToNull();
    this.loader = true;

    if (this.onlyActive) {
      this.apiQuery.addFilters({ active: true });
    }

    if (this.includes) {
      this.apiQuery.addIncludes(this.includes);
    }

    this.companyService.index(this.apiQuery.setLimit(9999)).subscribe((response: PaginatedResponse) => {
      this.data = response.data;
      this.loader = false;
      this.patchForm();
    });
  }

  ngOnDestroy() {
    if (this.isDefaultSO) {
      this.setInputToNull();
    }
  }

  // loadCompanyById(id: number) {
  //   this.loader = true;
  //   this.companyService.show(id).subscribe((company: Company) => {
  //     this.data = [company];
  //     this.loader = false;
  //   });
  // }

  // companySearch() {
  //   this.input$
  //     .pipe(
  //       tap(() => (this.loader = true)),
  //       debounceTime(1000),
  //       distinctUntilChanged(),
  //       switchMap(term =>
  //         this.companyService.index(this.apiQuery.setLimit(9999).addFilter('name', term)).pipe(
  //           catchError(() => of([])), // empty list on error
  //           tap(() => (this.loader = false))
  //         )
  //       )
  //     )
  //     .subscribe((companies: PaginatedResponse) => {
  //       this.data = companies.data;
  //       this.loader = false;
  //     });
  // }

  onChange(company: any) {
    this.select.emit(company);

    if (this.parentFormGroup.get(this.companyFormControlName)) {
      this.parentFormGroup.get(this.companyFormControlName).patchValue(company || null);
    }
  }

  add(searchTerm: string) {
    this.companyFormService.open(new Company().deserialize({ name: searchTerm })).then(
      (response) => {
        this.loadCompanies();
        this.parentFormGroup.get(this.passFormControlName).setValue(response.id);
      },
      (err) => {
        log.error(err);
      }
    );
  }

  edit() {
    if (this.parentFormGroup.get(this.passFormControlName).value) {
      this.companyFormService
        .open(new Company().deserialize({ id: this.parentFormGroup.get(this.passFormControlName).value }))
        .then(
          (response) => {
            this.loadCompanies(); // @todo: като стигне до тук вече е кеширано, така че трябва да се измисли друго
            this.parentFormGroup.get(this.passFormControlName).setValue(response.id);
            if (this.parentFormGroup.get(this.companyFormControlName)) {
              this.parentFormGroup.get(this.companyFormControlName).patchValue(response);
            }
          },
          (err) => {
            log.error(err);
          }
        );
    }
  }
}
